module.exports = __webpack_public_path__ + "static/naverCafeLogo-ed5b1309356f2ab7e786677dac3586eb.png";